export default {
    state: {
        list: null,
        filters: {}
    },

    mutations: {
        ALERTPROBLEM_SET_LIST(state, list) {
            state.list = list
        },

        ALERTPROBLEM_SET_FILTER(state, {key, value}) {
            state.filters = {
                ...state.filters,
                [key]: value,
            }
        },
        SET_ALERTPROBLEM_LIST(state, list) {
            state.list = list
        },

        ALERTPROBLEM_SET_COUNT(state, count) {
            state.count = count
        },

        ALERTPROBLEM_RESET_FILTERS(state){
            state.filters = {
                search: '',
                users:[]
            }
        },

    },
}
